import React from 'react';
import styled from 'styled-components';
import { VerticalSpacerContentBlockValueCmsModel } from 'autogen/swagger/all';
import { breakpoint, sizes, spacers } from 'variables';

export type VerticalSpacerPlaceholderProps = {
    model: VerticalSpacerContentBlockValueCmsModel;
};

const StyledSpacer = styled.div<{ height: string }>`
    ${({ height }) => {
        switch (height) {
            case 'height-small':
                return `height: 10px;`;
            case 'height-medium':
                return `height: ${spacers.normal};`;
            case 'height-large':
                return `
                    height: ${spacers.large};
                    ${breakpoint.down(sizes.sm)} {
                        height: ${spacers.xlargeSm};
                    }
                `;
            case 'height-xlarge':
                return `height: ${spacers.xlarge};`;
            default:
                return '';
        }
    }}
`;

export default function VerticalSpacerPlaceholder(props: VerticalSpacerPlaceholderProps) {
    const { model } = props;
    const { height } = model;

    return <StyledSpacer height={height} />;
}
